import React, { useState } from 'react'
import moment from 'moment'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Popover, PopoverAnchor, PopoverContent } from '@/components/ui/popover'
import DatePicker from './date_picker'

// Text input that opens a calendar popover on focus. Same public API as
// before: `value` (moment-parseable), `onChange` (receives 'YYYY-MM-DD' on
// Save, '' on Clear — nothing is emitted until then), `placeholder`,
// `className`.
const formatDisplay = (value) => {
  if (!value) return ''
  const d = moment(value)
  return d.isValid() ? d.format('Do MMM YYYY') : value
}

const DatePickerInput = ({ value, onChange, placeholder, className }) => {
  const [open, setOpen] = useState(false)
  const [pending, setPending] = useState('')

  // Strip the legacy bootstrap default; anything else passes through.
  const classes = (className || '')
    .split(/\s+/)
    .filter((token) => token && token !== 'form-control')
    .join(' ')

  const onOpen = () => {
    setPending(value || '')
    setOpen(true)
  }

  const onSave = () => {
    setOpen(false)
    onChange(pending)
  }

  const onClear = () => {
    setOpen(false)
    onChange('')
  }

  const onCancel = () => {
    setOpen(false)
  }

  return (
    <Popover open={open} onOpenChange={(next) => (next ? onOpen() : setOpen(false))}>
      <PopoverAnchor asChild>
        <Input
          type="text"
          readOnly
          className={classes}
          placeholder={placeholder || ''}
          value={formatDisplay(value)}
          onFocus={onOpen}
          onClick={onOpen}
        />
      </PopoverAnchor>
      <PopoverContent align="start" className="w-auto" onOpenAutoFocus={(e) => e.preventDefault()}>
        <DatePicker value={pending} onChange={setPending} />
        <div className="mt-3 flex items-center justify-between gap-2 border-t pt-3">
          <Button size="sm" variant="ghost" onClick={onClear}>Clear</Button>
          <div className="flex gap-2">
            <Button size="sm" variant="ghost" onClick={onCancel}>Cancel</Button>
            <Button size="sm" onClick={onSave}>Save</Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default DatePickerInput
